import React from "react";
import styled from "styled-components";
import { Flex } from "reflexbox/src";
import { useRegisterStateValue } from "../../RegisterContext";
import { strings, withLocalizeStrings } from "../../../languages/Localize";
import { Box } from "reflexbox/styled-components";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const StyledSuccessfulPayment = styled(Flex)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
`;

const ContentBox = styled(Flex)`
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 0px 22px;
`;

const TitleBox = styled(Flex)`
    font-size: 24px;
    color: #fff;
    text-align: center;
`;

const DescriptionBox = styled(Flex)`
    font-size: 14px;
    color: #fff;
    text-align: center;
    && {
        margin-top: 20px;
    }
`;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.primary};
    width: 60%;
    min-width: 180px;
    height: 50px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 24px;
    &:focus,
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
    &:active {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const SuccessfulPayment = props => {
    const { monriFormValues } = useRegisterStateValue();

    const history = useHistory();

    const handleBackClick = () => {
        history.push("/");
    };

    const price = localStorage.getItem("price");

    return (
        <StyledSuccessfulPayment>
            <ContentBox>
                <TitleBox>{props.strings.register.successfulEPayment.title}</TitleBox>
                <DescriptionBox>
                    {price
                        ? props.strings.register.successfulEPayment.description.replace(
                              "{price}",
                              price.substring(0, price.length - 2) + "," + price.substring(price.length - 2)
                          )
                        : props.strings.register.descriptionNoPrice}
                </DescriptionBox>
            </ContentBox>
            <StyledButtonContainer sx={{ m: [3, 4], px: [1, 2], fontSize: [2, 3] }}>
                <StyledButton onClick={handleBackClick}>{strings.register.common.OK}</StyledButton>
            </StyledButtonContainer>
        </StyledSuccessfulPayment>
    );
};

export default withLocalizeStrings(SuccessfulPayment);
